import { IconProps } from './interfaces';

export const IconPlayButton = ({ className, fill }: IconProps) => {
    return (
        <svg className={className} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path
                    d="M24.1401 12.4853C25.3068 13.1589 25.3068 14.8428 24.1401 15.5164L8.38896 24.6103C7.2223 25.2839 5.76396 24.4419 5.76396 23.0948V4.90691C5.76396 3.55976 7.2223 2.71779 8.38896 3.39136L24.1401 12.4853Z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};
